import { assign, findIndex, remove, isEmpty } from 'lodash';
import  * as types from '../actions/ActionTypes';
import {Dictionary} from "../types/Dictionary";
import STATUSES from '../i18n/statuses';

import { goToLogin } from "../components/Utils";
import {isNull} from 'util';

export interface FormState {
    id: any,
    types: Array<any>,
    form: any,
    orn: any,
    projects: Array<any>,
    request_meta?: any,
    request_type_id?: number,
    data?: any,

    forms: Array<any>,
    loaders: any,
    values: Array<any>,
    section:string,
    listUserForms: Array<any>,
    checkedPanel: Array<string>,
    user: any,
    companies: Array<any>,
    countToSend: number,
    errors: Dictionary<any | undefined>,
    visited: Dictionary<boolean>,
    allVisited: boolean,
    readonly?: boolean,
    status?: number,
    formUid?: string,
    process_id?: number,
    form_type?: string
}

const defaultState : FormState = {
    types: [],
    id: null,
    form: {
        sections: [],
        values: []
    },
    companies: [],
    orn: null,
    projects: [],
    forms: null,
    loaders: {},
    values:[],
    section:'0',
    listUserForms:[],
    checkedPanel:[],
    user: {},
    countToSend: 0,
    errors: {},
    visited: {},
    allVisited: false
};

export interface CommonState {
    language: string,
    SDK: string,
}

const commonState : CommonState = {
    language: 'ru',
    SDK: '',
};

export interface Action{
    type:string;
    payload: any;
}

function updateControls(controls: any[], updater: (control: any) => void) {
    return controls.map(c => {
        if(c.controls) {
            c = {...c, controls: updateControls(c.controls, updater)};
        }

        return updater(c);
    })
}

// function updateStateControls(state: any, updater: (control: any) => void) {
//     const newForm = {
//         ...state.form,
//         sections: state.form.sections.map(s => ({
//             ...s,
//             controls: updateControls(s.controls, updater)
//         }))
//     };
//     return {...state, form: newForm};
// }

export function common(state: CommonState = commonState, action : Action){
    switch (action.type){
        case types.SET_LANGUAGE:
            state.language = action.payload;
            return assign({}, state);
        case types.SET_SDK:
            state.SDK = action.payload;
            return assign({}, state);
        default:
            return state;
    }
}

export function forms(state : FormState = defaultState, action : Action){
    switch(action.type){
        case types.LOADING_START:
            state.loaders[action.payload] = true;
            return assign({}, state, { loaders: { ...state.loaders }});
        case types.LOADING_FINISH:
            delete state.loaders[action.payload];
            return assign({}, state, { loaders: { ...state.loaders }});
        case types.SET_AVAILABLE_TYPES:
            return assign({}, state, { types: action.payload });
        case types.SET_REQUEST:
            // console.log('SET_REQUEST', action.payload);
            return assign({}, state, {
                ...action.payload,
                values: [
                    ...(isNull(action.payload.data) ? [] : action.payload.data.filter(item => !item.type || item.type !== 'file')),
                    ...action.payload.form_files.map(item => ({
                        controlid: item.field_id,
                        type: 'file',
                        value: {
                            inputs: [{
                                id: item.id,
                                value: item.name,
                                url: item.file_url,
                                isLoader: false
                            }],
                            isComment: false,
                            comment: '',
                            showHelp: false,
                            warningDesc: ''
                        }
                    }))
                ],
                form: {...action.payload.request_meta},
                status_id: STATUSES[action.payload.status] && STATUSES[action.payload.status].id || 0,
                status: action.payload.status,
                readonly: action.payload.is_locked
            });
        case types.FETCH_FORMS:
            return assign({}, state, { forms: action.payload });
        case types.SET_SECTION:
            return assign({},state,{ section:action.payload.id });
        case types.SET_PROJECTS:
            return assign({}, state, {
                projects: action.payload
            });
        case types.ADD_VALUE: {
            const stamp = +new Date();
            const valuesLookUp: { [key: string]: any }  = {};
            action.payload.forEach(p => valuesLookUp[p.controlid] = p.value);
            const newForm = {
                ...state.form,
                sections: state.form.sections.map(s => ({
                    ...s,
                    $$timestamp: stamp,
                    controls: updateControls(s.controls, c => ({...c, value: valuesLookUp[c.id]}))
                }))
            };
            return assign({}, state, {values: [...action.payload], form: newForm});
        }
        case types.CLEAR_VALUES:
            return assign({},state,{ values:[], form:{}, readonly: undefined, errors: {}, visited: {}, allVisited: false  });
        case types.SET_COMPANIES:
            return assign({},state,{ companies: action.payload });
        case types.AUTH_USER_SUCCESS:
            return assign({},state, { user: action.payload});
        case types.AUTH_USER_FAILED:
            goToLogin();
            return state;
        case types.FETCH_FORM:
            return assign({},state,{ form: action.payload, errors: {}, visited: {}, allVisited: false });
        case types.SET_ORN:
            return assign({},state, { orn: action.payload });
        // case types.FETCH_COMPANIES:
        //     return assign({}, state, { companies: action.payload.data || [] });

        case types.SET_FORM_UID:
            return assign({}, state, { formUid: action.payload } );
        case types.FETCH_VALUES:
            return assign({},state, { listUserForms: action.payload});
        case types.OPEN_FORM: {
            const valuesLookUp: { [key: string]: any }  = {};
            action.payload.values.forEach(p => valuesLookUp[p.controlid] = p.value);
            action.payload.form = {
                ...action.payload.form,
                sections: action.payload.form.sections.map(s => ({
                    ...s,
                    controls: updateControls(s.controls, c => ({...c, value: valuesLookUp[c.id] || c.value}))
                }))
            };

            return assign({}, state, {...action.payload, errors: {}, visited: {}, allVisited: false});
        }
        case types.CHECKED_PANEL:
            return action.payload.checked ?
                assign({},state, { checkedPanel: [...state.checkedPanel, action.payload.panelId] }) :
                assign({},state, { checkedPanel: remove(state.checkedPanel, (id) => id !== action.payload.panelId ) });

        case types.ATTEMPT_TO_SEND:
            return assign({},state,{ countToSend: action.payload });
        case types.SET_STATUS_DEFAULT:
            return assign({},state,{ status: action.payload });
        case types.CREATE_REQUEST_BEFORE:
            return assign({},state,{ checkedPanel: [] });
        case types.REQUEST_UNCHEK_UPDATE:
            let requests = [...state.listUserForms];
            let idx = findIndex(requests, (obj) => obj.formId === action.payload.formId &&
                                                    obj.valuesId === action.payload.valuesId);
            if(idx > -1){
                requests[idx].updateState = '';
            }
            return  assign({},state, { listUserForms: requests});
        case types.MARK_VISITED: {
            if (!state[action.payload]) {
                return {...state, visited: {...state.visited, ...{[action.payload]: true}}};
            }
            return state;
        }
        case types.SET_ERROR: {
            if(state.errors[action.payload.id] !== action.payload.error) {
                return {...state, errors: {...state.errors, ...{[action.payload.id]: action.payload.error}}};
            }
            return state;
        }
        case types.MARK_ALL_VISITED: {
            return {...state, errors: {}, allVisited: true};
        }
        default:
            return state;
    }
}
